import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'empty-records-legacy-component',
    // templateUrl: './empty-records-legacy.component.html',
    templateUrl: './empty-records-legacy.v2.component.html',
    styleUrls: ['./empty-records-legacy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmptyRecordsLegacyComponent {

  @Input() message: string;
  @Input() subMessage: string;
  @Input() labelButton: string;
  @Input() buttonClass: string = '';
  @Output() emitEvent = new EventEmitter();

  emit() {
    this.emitEvent.emit();
  }

}